import { showSmsRequest } from "./PageAuth";
import {loadCSS, hasComponentStylesheet} from "./Util";
/*import LockScroll from './LockScroll';*/

export default class Popup {
    constructor(popup) {
        this.$root = $(popup);
        this.name = this.$root.data('name');

        if (popup.rendered) App.D.trigger('popup:destroy', {dom: popup});
        popup.rendered = true;

        this.openedClass = 'common-popup--opened';
        this.closeClass = 'js-common-popup-close';
        this.contentClass = 'js-common-popup-content';
        this.isOpen = false;

        if (!this.$root.length) return [];

        this.render();
        this.bind();
    }



    // рендер попапа
    render() {

    }



    // события
    bind() {
        this.popupClick = this.triggerClick.bind(this);
        App.D.on('click', '[data-popup="' + this.name + '"]', this.popupClick);

        this.$root.on('click', '.' + this.closeClass, (e) => {
            if (e.target.nodeName != 'A') {
                e.preventDefault();
            }
            //this.close();
            $(e.currentTarget).trigger('popup:close');
        });

        // закрываем попап по клику на поля
        // this.$root.on('click', (e) => {
        //     if (e.target == this.$root[0]) {
        //         this.close();
        //     }
        // });

        // закрываем попап по всплытию события popup:close
        this.$root.on('popup:close', () => {
            this.close();
        });

        // Закрыть попап клавишей Escape
        // App.W.on('keydown.popup', (e) => {
        //     if (this.isOpen && e.keyCode == 27) {
        //         this.close();
        //     }
        // });

        // открываем попап
        this.popupOpen = this.triggerOpen.bind(this);
        App.D.on('popup:open', this.popupOpen);

        // удаляем обработчики
        this.popupDestroy = this.destroy.bind(this);
        App.D.on('popup:destroy', this.popupDestroy);
    }



    triggerClick(e) {
        e.preventDefault();

        if ($(e.currentTarget).closest('.js-common-popup').length) {
            $(e.currentTarget).closest('.js-common-popup').find('.' + this.closeClass).trigger('popup:close');
        }

        App.D.trigger('popup:open', {
            name: this.name
        });
    }



    triggerOpen(e, data) {
        if (data.name == this.name && !this.isOpen) {
            if (data.content) {
                $('.' + this.contentClass, this.$root).html(data.content);
            }

            if (!data.noResetForm) {
                // ресет success формы TODO: сделать иначе т.к. это не подходящее место для возврата состояния формы
                this.$root.find('.form').each(function (i, form) {
                    form.reset();
                    $(form).removeClass('_form-success _form-error _form-message');
                    if ($(form).is('.js-form-sms-request')) {
                        showSmsRequest();
                    }
                    $(form).find('.js-submit').removeAttr('disabled');
                });
            }

            this.$root.find('.js-form').each(function () {
                const formDom = this;

                import('./Form.js').then(function ({loadCaptchaForms}) {
                    loadCaptchaForms($(formDom));
                });
            });

            if (!hasComponentStylesheet('forms')) {
                loadCSS('/css/components/forms.css', () => {
                    this.open();
                });
            } else {
                this.open();
            }
        }
    }



    destroy(e, data) {
        if ((data.name && data.name == this.name) || (data.dom && data.dom === this.$root[0])) {
            if (this.isOpen) {
                this.$root.removeClass(this.openedClass);
                App.lockScroll.unlock();
            }
            App.D.off('click', '[data-popup="' + this.name + '"]', this.popupClick);
            App.D.off('popup:open', this.popupOpen);
            App.D.off('popup:destroy', this.popupDestroy);
            this.$root.off('popup:close');
            this.$root.off('click');
        }
    }



    open() {
        this.isOpen = true;
        this.$root.addClass(this.openedClass);
        setTimeout(() => {
            this.$root.trigger('popup:opened');
        }, 300);
        App.lockScroll.lock();
    }



    close() {
        this.isOpen = false;
        this.$root.removeClass(this.openedClass);
        this.$root.find('.js-video-frame-wrap iframe, .js-video-frame-wrap video').remove();

        setTimeout(() => {
            this.$root.trigger('popup:closed');
        }, 300);
        App.lockScroll.unlock();

        setTimeout(() => {
            if (this.$root.data('name') === 'productReview') {
                $('.popup-review-step').removeClass('_active');
                $('.js-popup-review-1').addClass('_active');
            }
        }, 500);
    }
}

App.D.ready(function () {
    if (location.hash) {
        $('[data-popup-hash]').each(function () {
            if ($(this).data('popup-hash') == location.hash.slice(1)) {
                App.D.trigger('popup:open', {
                    name: $(this).data('name')
                });
            }
        });
    }
});

App.D.on('click', '[href^="#"]', function (e) {
    const hash = $(e.currentTarget).attr('href').slice(1);
    const popup = $(`[data-popup-hash="${hash}"]`).eq(0);

    if (popup.length) {
        App.D.trigger('popup:open', {
            name: popup.data('name')
        });
    }
});


$('.js-common-popup').each(function () {
    new Popup(this);
});

$('.js-common-popup.common-popup--opened .js-form').each(function () {
    const formDom = this;

    import('./Form.js').then(function ({loadCaptchaForms}) {
        loadCaptchaForms($(formDom));
    });
});
